import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlusRegular = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M26 15.2497H16.75V5.99969C16.75 5.80078 16.671 5.61001 16.5303 5.46936C16.3897 5.32871 16.1989 5.24969 16 5.24969C15.8011 5.24969 15.6103 5.32871 15.4697 5.46936C15.329 5.61001 15.25 5.80078 15.25 5.99969V15.2497H6C5.80109 15.2497 5.61032 15.3287 5.46967 15.4694C5.32902 15.61 5.25 15.8008 5.25 15.9997C5.25 16.1986 5.32902 16.3894 5.46967 16.53C5.61032 16.6707 5.80109 16.7497 6 16.7497H15.25V25.9997C15.25 26.1986 15.329 26.3894 15.4697 26.53C15.6103 26.6707 15.8011 26.7497 16 26.7497C16.1989 26.7497 16.3897 26.6707 16.5303 26.53C16.671 26.3894 16.75 26.1986 16.75 25.9997V16.7497H26C26.1989 16.7497 26.3897 16.6707 26.5303 16.53C26.671 16.3894 26.75 16.1986 26.75 15.9997C26.75 15.8008 26.671 15.61 26.5303 15.4694C26.3897 15.3287 26.1989 15.2497 26 15.2497Z",
		fill: "currentColor"
	})
});
export default SvgPlusRegular;
